<template>
  <div>
    <div class="modal-title">{{ $t('tour_new_place_title') }}</div>
    <div class="modal-content">
      <p class="mt-4 text-label text-xs">{{ $t('tour_destination_label') }}</p>
      <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
          <path d="M24,37L0,13.1h48L24,37z"/>
        </svg>
      </div>
      <select v-model="placeId" class="modal-select">
        <option v-for="place in places" v-bind:key="place.id" v-bind:value="place.id">
          {{ place.name }} &nbsp; ({{$t('tour_about_label')}}{{ Math.ceil(place.distance * 10) / 10 }}km)
        </option>
      </select>
      <div v-if="this.isStay">
        <p class="mt-4 text-label text-xs">{{ $t('tour_checkin_label') }}</p>
        <checkin-time-select v-model="checkinTime" />
        <p class="mt-4 text-label text-xs">{{ $t('tour_checkout_label') }}</p>
        <checkout-time-select v-model="checkoutTime" />
      </div>
      <div v-else>
        <p class="mt-4 text-label text-xs">{{ $t('tour_residence_time_label') }}</p>
        <time-select v-model="time" />
      </div>
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="handleClick">{{ $t('tour_add') }}</a>
    </div>
  </div>
</template>

<script>
import TimeSelect from "./TimeSelect"
import CheckoutTimeSelect from "./CheckoutTimeSelect"
import CheckinTimeSelect from "./CheckinTimeSelect"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    TimeSelect,
    CheckoutTimeSelect,
    CheckinTimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      placeId: undefined,
      time: 60,
      places: [],
      timeOptions: [],
      isStay: false,
      checkinTime: undefined,
      checkoutTime: undefined
    }
  },
  created: function () {
    let startTime = this.$store.getters['condition/getTime']
    // デフォルトのチェックイン／アウト時間は18:00／10:00
    this.checkinTime = moment(startTime).set('hour', 18)
    this.checkoutTime = moment(startTime).add(1, 'days').set('hour', 10)
  },
  mounted () {
    this.getPlace()
  },
  methods: {
    getPlace: function () {
      this.places = this.$store.getters['favorites/getFavoritedPlacesWithDistance'](this.target.route)
      if (this.places.length > 0) {
        this.placeId = this.places[0].id
      }
    },
    handleClick: function () {
      const place = this.$store.getters['places/getPlace'](this.placeId)
      if (place.genreIds.indexOf('TH6_tag159') != -1) {
        const visitTime = this.checkoutTime.diff(this.checkinTime, 'minutes', false)
        this.time = visitTime
        this.$store.dispatch('condition/updateTime', this.checkinTime)
      }
      this.callback(this.target.route, this.time, place)
    }
  },
  watch: {
    target: function () {
      this.getPlace()
    }
  }
}
</script>
